import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import SiteTakeoverBackgroundImage from './SiteTakeoverBackgroundImage'
import useCurrentSiteTakeover, { SiteTakeoverContext } from 'hooks/useCurrentSiteTakeover'
import { themeClassName } from 'lib/theme/themeUtils'
import LayoutContainer from '../LayoutContainer'

const Background = styled(SiteTakeoverBackgroundImage)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
`

const Content = styled(Group)`
  transform: translateZ(0);
`

const Banner = styled(Group)`
  padding: ${rem(12)};
  position: relative;
  min-height: ${rem(60)};
`

interface Props {
  context?: SiteTakeoverContext
}
function SiteTakeoverOfferPageBanner({ context }: Props) {
  const siteTakeover = useCurrentSiteTakeover(context)

  if (!siteTakeover?.offerPage) {
    return null
  }

  return <Banner direction="horizontal" verticalAlign="center">
    <Background background="default" context={context}/>
    <LayoutContainer>
      <Content
        direction="horizontal"
        gap={12}
        verticalAlign="center"
        horizontalAlign="start"
        tabletHorizontalAlign="center"
        className={themeClassName(siteTakeover.palette)}
      >
        <BodyText variant="medium">
          {siteTakeover.offerPage.content}
        </BodyText>
      </Content>
    </LayoutContainer>
  </Banner>
}

export default SiteTakeoverOfferPageBanner
